<div class="rpcs-modal" style="min-width: 320px; max-width: 460px;">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
    <div class="flex items-center gap-2">
      <mat-icon style="color:#1C593D;">visibility</mat-icon>
      <h2 class="text-base font-bold text-gray-800">Vista cliente — Envío a Perú</h2>
    </div>
    <button (click)="close()" class="text-gray-400 hover:text-gray-700"><mat-icon>close</mat-icon></button>
  </div>

  <div class="px-5 py-4">
    <p class="text-xs text-gray-400 mb-3">Así vería la cotización el cliente (sin datos internos).</p>

    <!-- Inputs -->
    <div class="flex flex-col gap-3 mb-4">
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Origen (con qué paga)
        <select [(ngModel)]="origen" (ngModelChange)="onOrigenChange()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white text-gray-700">
          <option *ngFor="let o of origenes" [value]="o.code">{{ o.label }}</option>
        </select></label>

      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">¿Cuánto envía? ({{ esVes ? 'VES' : esClp ? 'CLP' : 'USD' }})
        <input type="number" [step]="esVes || esClp ? 1000 : 1" min="0" [(ngModel)]="monto"
          class="border border-gray-300 rounded-lg px-3 py-2 text-base font-bold text-gray-800" /></label>

      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Forma de entrega
        <select disabled class="border border-gray-300 rounded-lg px-3 py-2 text-sm bg-gray-50 text-gray-700">
          <option>Instantáneo (interbancario · CCI)</option>
        </select></label>

      <button (click)="cotizar()" [disabled]="loading"
        class="mt-1 px-4 py-2.5 rounded-xl text-white font-bold" style="background:#1C593D;">
        {{ loading ? 'Calculando…' : 'Calcular' }}
      </button>
    </div>

    <div *ngIf="error" class="px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">{{ error }}</div>

    <!-- Resultado -->
    <ng-container *ngIf="result">
      <ng-container *ngIf="result.disponible; else noDisponible">
        <!-- ░░ SEGMENTO CLIENTE ░░ -->
        <div class="rounded-2xl p-5 text-center" style="background:linear-gradient(135deg,#f0fdf4,#ecfdf5);border:1px solid #bbf7d0;">
          <p class="text-xs text-gray-500 uppercase font-semibold">El destinatario recibe</p>
          <p class="text-3xl font-extrabold my-1" style="color:#1e5a3f;">
            {{ result.resultado?.recibe | number:'1.2-2' }} <span class="text-lg">PEN</span>
          </p>
          <div class="grid grid-cols-2 gap-2 mt-3 text-sm">
            <div><p class="text-xs text-gray-400">Tasa</p><p class="font-bold text-gray-700">{{ tasaClienteValor | number:tasaClienteFmt }}</p></div>
            <div><p class="text-xs text-gray-400">Llega en</p><p class="font-bold text-gray-700">{{ plazoLabel }}</p></div>
          </div>
          <p class="text-[11px] text-gray-400 mt-3">Envías {{ montoEnviado | number:(esVes || esClp ? '1.0-0' : '1.0-2') }} {{ esVes ? 'VES' : esClp ? 'CLP' : 'USD' }}</p>
        </div>

        <div *ngIf="bajoMinimo" class="mt-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-800">
          ⚠️ Bajo el mínimo de 20 USD: el cliente no podría enviar este monto.
        </div>
        <div *ngIf="!ofrecible" class="mt-2 px-3 py-2 rounded-lg bg-gray-100 border border-gray-300 text-xs text-gray-600">
          ⚪ No se ofrece al cliente ahora (país inactivo o sin margen): esto es solo simulación.
        </div>

        <!-- ░░ SEGMENTO ADMIN (solo Aguacate) ░░ -->
        <div class="rounded-2xl p-4 mt-3" style="background:#0f172a;color:#e2e8f0;">
          <p class="text-[11px] uppercase font-bold mb-2" style="color:#fbbf24;">🔒 Solo Aguacate — cómo se compone</p>
          <div class="text-sm" style="line-height:1.7;">
            <ng-container *ngIf="esVes && ves">
              <div class="flex justify-between"><span class="text-slate-400">Cliente paga</span><span>{{ ves.montoVes | number:'1.0-0' }} VES</span></div>
              <div class="flex justify-between"><span class="text-slate-400">Tasa VES/USDT (con markup)</span><span>{{ ves.tasaVesUsd | number:'1.2-4' }}</span></div>
              <div class="flex justify-between border-b border-slate-700 pb-1 mb-1"><span class="text-slate-400">= Convertido a USD</span><span>{{ ves.montoUsd | number:'1.2-4' }} USD</span></div>
            </ng-container>
            <ng-container *ngIf="esClp && clp">
              <div class="flex justify-between"><span class="text-slate-400">Cliente paga</span><span>{{ clp.montoClp | number:'1.0-0' }} CLP</span></div>
              <div class="flex justify-between"><span class="text-slate-400">Tasa CLP/USD (con markup)</span><span>{{ clp.tasaClpUsd | number:'1.2-2' }}</span></div>
              <div class="flex justify-between border-b border-slate-700 pb-1 mb-1"><span class="text-slate-400">= Convertido a USD</span><span>{{ clp.montoUsd | number:'1.2-4' }} USD</span></div>
            </ng-container>
            <div class="flex justify-between"><span class="text-slate-400">{{ esVes || esClp ? 'Puente interno' : 'Cliente envía' }}</span><span>{{ result.resultado?.montoUsd | number:'1.2-2' }} USD</span></div>
            <div class="flex justify-between"><span class="text-slate-400">Tasa pública (referencia)<span *ngIf="result.publicaFallback"> *</span></span><span>{{ result.resultado?.tasaPublica | number:'1.4-4' }}</span></div>
            <div class="flex justify-between"><span class="text-slate-400">− Comisión Aguacate</span><span>{{ result.resultado?.comisionAguacateUsd | number:'1.2-4' }} USD ({{ result.resultado?.markupEfectivoPct | number:'1.2-2' }}%)</span></div>
            <div class="flex justify-between"><span class="text-slate-400">− Fee Vita</span><span>{{ result.resultado?.feeVitaLocal | number:'1.2-2' }} PEN</span></div>
            <div class="flex justify-between border-t border-slate-700 mt-1 pt-1"><span class="text-slate-400">= Destinatario recibe</span><span class="font-bold">{{ result.resultado?.recibe | number:'1.2-2' }} PEN</span></div>
            <div class="flex justify-between mt-1"><span class="text-slate-400">Compramos a (partner)</span><span>{{ result.resultado?.tasaPartner | number:'1.4-4' }} ({{ result.tasaSource }})</span></div>
            <div class="flex justify-between"><span class="text-slate-400">Spread púb↔partner</span><span>{{ result.resultado?.spreadPct | number:'1.2-2' }}%</span></div>
            <div class="flex justify-between"><span class="text-slate-400">Costo de fondeo</span><span>{{ result.resultado?.costoUsd | number:'1.2-4' }} USD</span></div>
            <div class="flex justify-between border-t border-slate-700 mt-1 pt-1 text-base">
              <span class="font-bold" style="color:#86efac;">Ganancia Aguacate</span>
              <span class="font-extrabold" style="color:#86efac;">{{ result.resultado?.gananciaUsd | number:'1.2-4' }} USD</span>
            </div>
          </div>
          <p *ngIf="result.publicaFallback" class="text-[11px] text-amber-300 mt-2">* Sin pública USD en vivo: se usó la tasa del riel como referencia (margen de tasa = 0, ganás solo la comisión).</p>
          <p *ngIf="result.paisActivo === false" class="text-[11px] text-amber-300 mt-1">⚠️ País inactivo: esto es solo simulación, no se ofrece al cliente.</p>
        </div>
      </ng-container>

      <ng-template #noDisponible>
        <div class="rounded-2xl p-5 text-center bg-amber-50 border border-amber-200 text-amber-800 text-sm">
          <mat-icon class="mb-1">info</mat-icon>
          <p>{{ result.motivo || 'No se pudo cotizar ahora.' }}</p>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
